export default __webpack_public_path__ + "static/media/con_frEND03.fa550736.jpg";